import { Logger } from './logger';

let logger: Logger;

export const resources = () => {
  if (logger === undefined) {
    logger = new Logger();
  }

  return { logger };
};

export default resources();
